/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import BaseStat from './base-stat';

export default BaseStat.extend({
  failureUrl: attr('string'),
  failedSelector: attr('string'),
  tourStepId: attr('number'),
});
